<template>
    <gofix-card class="mb-0 heig-frame-child" fullContent>
        <gofix-default-table :settings="tableConfig" :table-items="tableItems" :tbody-tr-class="rowClass" @load-items="getTableData" @delete-items="deleteItems" @new-item="gotoDetail" @row-click="gotoDetail" @export="exportCSV" ref="gofixTable">
            <template slot="gofix_table:proposed_timeline" slot-scope="row">
                {{row.item.proposed_timeline | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
            </template>
            <template slot="gofix_table:created_at" slot-scope="row">
                {{row.item.created_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
            </template>
            <template slot="gofix_table:updated_at" slot-scope="row">
                {{row.item.updated_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
            </template>
            <template slot="gofix_table:completion_rate" slot-scope="row">
                {{ row.item.completion_rate ? `${row.item.completion_rate}%` : '' }}
            </template>
            <template slot="gofix_table:activity_updated_at" slot-scope="row">
                {{row.item.activity_updated_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
            </template>
            <template slot="gofix_table:actions" slot-scope="data" v-if="data.item.status === 'Closed'">
                <b-form-checkbox disabled></b-form-checkbox>
            </template>
        </gofix-default-table>
    </gofix-card>
</template>
<script>

import { mapGetters } from 'vuex';
import { filters } from '@/_filterVar.js'
import moment from 'moment';
export default {
    name: 'case-hot-button',
    props:["case_status"],
    data() {
        let filter = JSON.parse(JSON.stringify(filters['case_management_hot_button']));
        let dataSelect = {
            status: {
                value: [
                    // {value: 'Assigned', text: 'Assigned'},
                    {value: 'Open', text: 'Open'},
                    {value: 'Closed', text: 'Closed'},
                    // {value: 'Cancel', text: 'Cancel'}
                ],
                value_field: 'value',
                text_field: 'text'
            },
            avenue_of_feedback: {
                value: [
                    {value: 'Hot Button', text: 'Hot Button'},
                    {value: 'Estate Spot Check', text: 'Estate Spot Check'},
                ],
                value_field: 'value',
                text_field: 'text'
            }
        }
        if(this.case_status == 'Opening') {
            dataSelect.status.value = [
                // {value: 'Assigned', text: 'Assigned'},
                {value: 'Open', text: 'Open'},
            ]
        }
        if(this.case_status == 'Closed') {
            dataSelect.status.value = [
                {value: 'Closed', text: 'Closed'},
            ]
        }
        return {
            tableConfig: {
                name: 'case-hot-button-listing',
                controls: {
                    create: this.$checkRole(this.$accessModule.case_management, 'create'),
                    delete: this.$checkRole(this.$accessModule.case_management, 'delete'),
                    tableImport: false,
                    tableExport: true,
                },
                filter: filter,
                dataSelect: dataSelect,
                page: 1,
                limit: 100,
                total: 0,
                useDatabaseView: true,
                sortColumn: "id",
                sortDirection: "desc",
            },
            tableItems: [],
        }
    },
    watch: {
    },
    computed: {
        ...mapGetters({
            ClientContractID: 'ContractController/ClientContractID',
            currentRoles: 'AuthController/roles',
        })
    },
    created() {},
    methods: {
        /*---------- Table event ----------*/
        async getTableData(callback) {
            const { tableRequest, resolve, reject } = await callback();
            if(this.case_status && (this.case_status == 'Opening' || this.case_status == 'Closed') &&
                (
                    (Array.isArray(tableRequest.filter.status.value) && !tableRequest.filter.status.value.length) ||
                    (!Array.isArray(tableRequest.filter.status.value) && !tableRequest.filter.status.value)
                )
            ) {
                if(this.case_status == 'Opening') {
                    tableRequest.filter.status.value = ['Open'];
                } else {
                    tableRequest.filter.status.value = this.case_status;
                }
                
            }
            await this.$store.dispatch("CaseHotButtonController/getList", tableRequest)
                .then(response => {
                    this.tableItems = response.data.data.items;
                    this.tableConfig.total = response.data.data.total;
                    resolve(response.data.data);
                })
                .catch(err => {
                    this.$alertNotification("Can not load the case management", "danger");
                    reject();
                })
        },
        async deleteItems(callback) {
            const { ids, filter, resolve, reject } = await callback();
            this.$store.dispatch("CaseHotButtonController/deteleItem", ids)
                .then(response => {
                    resolve(this.$notificationV2('deleting', 'case'))
                })
                .catch(err => {
                    reject(err);
                });
        },
        async gotoDetail(item) {
            return this.$router.push({
                name: 'case-detail-hb-info',
                params: {
                    id: item && item.id ? item.id : 0
                }
            })
        },
        /*----------------------------------------*/
        exportCSV(tableRequest) {
            let request = JSON.parse(JSON.stringify(this.$refs.gofixTable.tableRequest));
            this.$store.dispatch('CaseHotButtonController/exportCsv',request)
                .then(response => {
                    let nameFile = 'CaseList.xlsx';
                    if(response.headers["content-disposition"]) {
                        let arrTemp = response.headers["content-disposition"].split("filename=");
                        if(arrTemp[1]) {
                            nameFile = arrTemp[1].replaceAll('"', "");
                        }
                    }
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', nameFile); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                })
        },
        /*----------------------------------------*/
        rowClass(item, type) {
            if (item) {
                if (item.status === "Open") {
                    return 'row-case-new';
                }
            }
            return null;
        }
    }
}
</script>
